import { NotificationLineWebSocketMessage } from '@/shared/services/notification';

export interface NotificationState {
  notifications: NotificationLineWebSocketMessage[];
  isAllowPushNotifications: boolean;
}

export const manyStatement = {
  title: 'STATEMENT.NOTIFICATIONS.TITLE_MANY',
  text: 'STATEMENT.NOTIFICATIONS.MESSAGE.MANY_STATEMENT',
};

export enum NotificationStatus {
  READ = 'READ',
  SENT = 'SENT',
}
